import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import { Header } from "../BasicInfo/Edit";

import * as style from "./styles.module.scss";
import ProfileImage from "../ProfileImage";
import history from "../../history";

const AccountSettings = () => {
  const [hasChangedPassword, setPasswordChanged] = useState(false);
  const [isProfileImagePopupOpen, setProfileImagePopupOpen] = useState(
    !!document.location.search.includes("openProfileImage")
  );

  const handleUpdatePasswordClick = async () => {
    window.location.href = "/my-account/change-password";
  };

  return (
    <Fragment>
      <div className={style.container}>
        <h2 className="section-header">My account</h2>
        <div className={style.container__form_container}>
          <div className={isProfileImagePopupOpen ? "d-none d-lg-block" : ""}>
            <div className={style.container__form}>
              <div className={style.container__form_group}>
                <h3>Update your password</h3>
                {!hasChangedPassword && (
                  <button
                    className="btn font-weight-bold text-dark btn-outline-info"
                    onClick={handleUpdatePasswordClick}
                  >
                    Update password
                  </button>
                )}
                {hasChangedPassword && (
                  <p className="p-1">✔ Your password has been updated.</p>
                )}
              </div>
              <div className={style.container__form_group}>
                <h3>Update your profile image</h3>
                <button
                  className="btn font-weight-bold text-dark btn-outline-info"
                  onClick={() => setProfileImagePopupOpen(true)}
                >
                  Choose a profile image
                </button>
              </div>
            </div>
            <div className={style.container__buttons}>
              <Link
                to="/profile"
                style={{ minWidth: "175px" }}
                className="btn btn-primary"
              >
                Back to My Account
              </Link>
            </div>
          </div>
          <ProfileImage
            isOpen={isProfileImagePopupOpen}
            setOpen={setProfileImagePopupOpen}
            popupOnMobile={false}
            customCancelHandler={() =>
              !!document.location.search.includes("openProfileImage") &&
              history.push("/profile")
            }
          />
        </div>
      </div>
    </Fragment>
  );
};

export default AccountSettings;
